export default "__VITE_ASSET__H2$tmeXy__"